/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_NewInputs */

const th_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างการประชุม`)
};

const en_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New meeting`)
};

const ja_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミーティングを作成`)
};

const zh_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建会议`)
};

const es_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva reunión`)
};

const pt_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova reunião`)
};

const id_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertemuan baru`)
};

const fr_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle réunion`)
};

const tl_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagong miting`)
};

const vi_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuộc họp mới`)
};

const ko_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 회의`)
};

const de_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Meeting`)
};

const ru_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая встреча`)
};

const tr_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni toplantı`)
};

const it_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova riunione`)
};

const pl_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe spotkanie`)
};

const uk_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова зустріч`)
};

const hi_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई बैठक`)
};

const ar_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجتماع جديد`)
};

const ms_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesyuarat baharu`)
};

const bn_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন সভা`)
};

const zh_tw2_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增會議`)
};

const zh_hk2_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增會議`)
};

const ur_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نئی ملاقات`)
};

const fa_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلسهٔ تازه`)
};

const sw_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkutano mpya`)
};

const nl_meeting_new = /** @type {(inputs: Meeting_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw gesprek`)
};

/**
* | output |
* | --- |
* | "New meeting" |
*
* @param {Meeting_NewInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_new = /** @type {((inputs?: Meeting_NewInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_NewInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_new(inputs)
	if (locale === "ja") return ja_meeting_new(inputs)
	if (locale === "zh") return zh_meeting_new(inputs)
	if (locale === "es") return es_meeting_new(inputs)
	if (locale === "pt") return pt_meeting_new(inputs)
	if (locale === "id") return id_meeting_new(inputs)
	if (locale === "fr") return fr_meeting_new(inputs)
	if (locale === "tl") return tl_meeting_new(inputs)
	if (locale === "vi") return vi_meeting_new(inputs)
	if (locale === "ko") return ko_meeting_new(inputs)
	if (locale === "de") return de_meeting_new(inputs)
	if (locale === "ru") return ru_meeting_new(inputs)
	if (locale === "tr") return tr_meeting_new(inputs)
	if (locale === "it") return it_meeting_new(inputs)
	if (locale === "pl") return pl_meeting_new(inputs)
	if (locale === "uk") return uk_meeting_new(inputs)
	if (locale === "hi") return hi_meeting_new(inputs)
	if (locale === "ar") return ar_meeting_new(inputs)
	if (locale === "ms") return ms_meeting_new(inputs)
	if (locale === "bn") return bn_meeting_new(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_new(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_new(inputs)
	if (locale === "ur") return ur_meeting_new(inputs)
	if (locale === "fa") return fa_meeting_new(inputs)
	if (locale === "sw") return sw_meeting_new(inputs)
	if (locale === "nl") return nl_meeting_new(inputs)
	return en_meeting_new(inputs)
});